import { forwardRef } from 'react';
import { AccessibleIcon as RadixAccessibleIcon } from '@radix-ui/themes';
import type { RadixAccessibleIconProps } from '@/types/radix-ui';

/**
 * AccessibleIcon component - wrapper around Radix UI AccessibleIcon
 * Provides accessible icon utilities for screen readers
 */
export type AccessibleIconProps = RadixAccessibleIconProps;

const AccessibleIcon = forwardRef<SVGSVGElement, AccessibleIconProps>(
  (props, ref) => {
    return <RadixAccessibleIcon ref={ref} {...props} />;
  }
);

AccessibleIcon.displayName = 'AccessibleIcon';

export { AccessibleIcon };
